"use strict";

import jQuery from 'jquery';

/**
 * @enum
 * @type {{MESSAGE: string, INPUT: string, CONFIRM: string}}
 */
gc.gis.widget.GCDialogType = {
	MESSAGE:        'dialog-message',
	INPUT:          'dialog-input',
	CONFIRM:        'dialog-confirm',
	CUSTOM:         'dialog-custom'
};

/**
 * @enum
 * @type {{DEFAULT: string, PRIMARY: string, SUCCESS: string, DANGER: string}}
 */
gc.gis.widget.GCDialogButtonType = {
	DEFAULT:        'button-default',
	PRIMARY:        'dialog-primary',
	SUCCESS:        'button-success',
	DANGER:         'dialog-danger'
};


/**
 * @classdesc
 * Dialog-Widget.
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen.
 * @param {string} options.title Überschrift.
 * @param {gc.gis.widget.GCDialogType} options.type Dialogtyp.
 * @param {jQuery} options.content Inhaltselement.
 * @param {boolean} [options.draggable=true] Flag, ob der Dialog verschoben werden darf.
 * @param {function} [options.submit] Benötig, wenn Typ INPUT oder CONFIRM ist.
 * @param {function} [options.reset] Callback beim Reset.
 * @param {function} [options.cancel] Callback beim Abbruch.
 * @param {function} [options.custom] Callback für nutzerdefinierte Dialog-Buttons.
 * @param {Array.Object<string,*>} [options.buttons] Nutzerdefinierte Dialog-Buttons.
 */
gc.gis.widget.GCDialog = function( options )
{
	gc.gis.widget.GCWidget.call( this, options );

	this.title = options.title || 'Dialog';
	this.type = options.type;
	this.element_content_body = options.content;
    this.draggable = options.draggable || true;
	this.submit_callback = options.submit;
	this.reset_callback = options.reset;
	this.cancel_callback = options.cancel;
	this.custom_callback = options.custom;
	this.custom_buttons = options.buttons || [];

	this._render();
};
gc.gis.widget.GCDialog.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * Schließt und entfernt den Dialog aus seinem Parent.
 *
 * @public
 * @method
 */
gc.gis.widget.GCDialog.prototype.dispose = function()
{
	var self = this;

	this.getElement().on('hidden.bs.modal', function() {
		self.getElement().remove();
	});
	this.getElement().modal('hide');
	gc.gis.iface.ui._dialog_container.hide('fade');
};

/**
 * Zeigt den Dialog an.
 *
 * @public
 * @method
 */
gc.gis.widget.GCDialog.prototype.show = function()
{
	gc.gis.iface.ui._dialog_container.html( this.getElement() );
	gc.gis.iface.ui._dialog_container.show('fade');

	this.getElement().modal({
		backdrop: false,
        keyboard: true
	});

	this.getElement().modal('show');
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCDialog.prototype._render = function()
{
	var element_content = jQuery('<div>', {
		'class': 'modal-content'
	});

    // '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>'
	element_content.append( jQuery('<div>', {
		'class': 'modal-header',
		html: '<strong class="modal-title"><span>'+ this.title +'</span></strong>'
	}) );

	element_content.append( jQuery('<div>', {
		'class': 'modal-body',
		html: this.element_content_body
	}) );

	this.actionbar = new gc.gis.widget.GCWidgetGroup(
		this.__initActionbarConfig()
	);
	element_content.append( this.actionbar.getElement() );

	var element_content_wrapper = jQuery('<div>', {
		'class': 'modal-dialog',
		role: 'document',
		html: element_content
	});

	this.element = jQuery('<div>', {
		'class': 'gc-widget-dialog modal fade',
		role: 'dialog',
		html: element_content_wrapper
	});

	if (this.draggable) {
        this.element.draggable({
            handle: ".modal-header"
        });
        element_content.find('.modal-header').addClass('gc-draggable-area');
    }

	return this.element;
};

/**
 * Initialisiert Actionbar-Buttons anhand des Dialog-Typs.
 *
 * @private
 * @method
 * @returns {{containerClassName: string, items: Array<gc.gis.widget.GCItem>}}
 */
gc.gis.widget.GCDialog.prototype.__initActionbarConfig = function()
{
	return {
		containerClassName: 'gc-widget-dialog-actionbar modal-footer',
		items: this.type !== gc.gis.widget.GCDialogType.CUSTOM ?
			this.__initActionbarButtons() : this.__initActionbarCustomButtons()
	};
};

/**
 * Erzeugt die Actionbar-Buttons anhand des Dialog-Typs (nicht nutzerdefiniert).
 *
 * @private
 * @method
 * @returns {Array<gc.gis.widget.GCItem>} Liste der Buttons
 */
gc.gis.widget.GCDialog.prototype.__initActionbarButtons = function()
{
	var buttons = [],
		self = this,
		item_reset = undefined,
		label_submit = '',
		label_cancel = 'Abbrechen',
		class_cancel = 'btn btn-default';

	switch (this.type)
	{
		case gc.gis.widget.GCDialogType.MESSAGE:
			label_cancel = 'Schließen';
			class_cancel = 'btn btn-primary';
			break;

		case gc.gis.widget.GCDialogType.CONFIRM:
			label_submit = 'Ja';
			label_cancel = 'Nein';
			class_cancel = 'btn btn-danger';
			break;

		case gc.gis.widget.GCDialogType.INPUT:
			class_cancel = 'btn btn-danger';
			label_submit = 'OK';

			if(typeof this.reset_callback === 'function')
			{
				item_reset = new gc.gis.widget.GCItem({
					label: 'Zurücksetzen',
					className: 'btn btn-primary',
					//icon: 'glyphicon glyphicon-ok',
					click: function (evt) {
						self.reset_callback(self);
					}
				});
			}
			break;
	}

	if(label_submit !== '')
	{
		buttons.push( new gc.gis.widget.GCItem({
			label: label_submit,
			className: 'btn btn-success',
			//icon: 'glyphicon glyphicon-ok',
			click: function( evt ) {
				if( typeof self.submit_callback === 'function')
				{
					self.submit_callback(self);
				}
			}
		}) );
	}

	if(item_reset)
	{
		buttons.push( item_reset );
	}

	buttons.push( new gc.gis.widget.GCItem({
		label: label_cancel,
		className: class_cancel,
		//icon: 'glyphicon glyphicon-remove',
		click: function( evt ) {
			if( typeof self.cancel_callback === 'function')
			{
				self.cancel_callback(self);
			}
			self.dispose();
		}
	}) );

	return buttons;
};

/**
 * Erzeugt die nutzerdefinierten Actionbar-Buttons.
 *
 * @private
 * @method
 * @returns {{containerClassName: string, items: Array<gc.gis.widget.GCItem>}}
 */
gc.gis.widget.GCDialog.prototype.__initActionbarCustomButtons = function()
{
	var buttons = [],
		self = this,
		type_css,
		btn,
		i, ii;

	for (i = 0, ii = this.custom_buttons.length; i < ii; i++)
	{
		btn = this.custom_buttons[i];
		switch (btn.type)
		{
			case gc.gis.widget.GCDialogButtonType.PRIMARY:
				type_css = 'btn-primary';
				break;
			case gc.gis.widget.GCDialogButtonType.SUCCESS:
				type_css = 'btn-success';
				break;
			case gc.gis.widget.GCDialogButtonType.DANGER:
				type_css = 'btn-danger';
				break;
			default:
				type_css = 'btn-default';
		}

		(function(inner_btn) {
			buttons.push( new gc.gis.widget.GCItem({
				label: btn.label || 'Unbenannt',
				className: 'btn ' + type_css,
				click: function(evt)
				{
					if (typeof self.custom_callback === 'function')
					{
						// TODO Button-Name oder Key übergeben
						self.custom_callback(self, inner_btn);
					}
				}
			}) );
		})(btn);

	}

	return buttons;
};